module.exports = __webpack_public_path__ + "static/media/uit6.05327cb3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/uit6.jpg
// module id = 5810
// module chunks = 0